import moment from 'moment';

export const formatDateTime = (dateString, format) => {
  if (!dateString) return '';
  return moment(dateString).format(format);
};

// Backend timestamps are in UTC; Sri Lanka is UTC+5:30 with no DST.
export const formatDateTimeSriLanka = (dateString, format) => {
  if (!dateString) return '';
  return moment.utc(dateString).utcOffset(330).format(format);
};

export const datesStartOfEndOf = (dateString, mode) => {
  if (!dateString) return '';
  if (mode === 'start') return moment(dateString).startOf('day');
  if (mode === 'end') return moment(dateString).endOf('day');
};

// Redemption amounts carry 4 decimal places from the backend; show them in full.
export const formatRedemptionAmount = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return 'N/A';
  return Number(amount).toFixed(4);
};
